var React = require('react');

function Brflag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#43ae5e","d":"M0 0h774.5v542.2H0z","key":0}),React.createElement("path",{"d":"M65.8 271l321.5 205.3 321.4-205.2L387.3 65.8 65.8 271.1z","fill":"#f7ea52","key":1}),React.createElement("circle",{"cx":"387.3","cy":"271.1","r":"135.5","fill":"#527cbe","key":2}),React.createElement("path",{"d":"M523.8 287a136.9 136.9 0 01-8.2 33.8c-10.2-11.1-46-46.2-113.4-71.8-73.7-28-132.8-26.6-144.1-26l15.8-30c27 .5 78 5 138.9 28.1 55.5 21.1 91.4 48 111 65.9z","fill":"#fff","key":3}),React.createElement("path",{"d":"M522.8 286.5c-1.3 11.6-4 22.8-8.1 33.3-10-11-45.3-45.5-111.6-70.7-72.5-27.6-130.8-26.1-142-25.5a135 135 0 0115.6-29.6c26.6.4 77 4.9 136.8 27.7 54.6 20.8 90 47.3 109.3 64.8z","fill":"none","key":4})]);
}

Brflag.defaultProps = {"overflow":"visible","viewBox":"0 0 774.5 542.2"};

module.exports = Brflag;

Brflag.default = Brflag;
